$(document).on('click', 'a.conversion', function () {
  gtag('event', 'conversion', {
    'send_to': 'AW-655069021/ChtNCJPw78wBEN2errgC'
  });
});
